<script>
  import {createEventDispatcher} from 'svelte';
  import Modal from "./Modal.svelte";
  import Icono from "../UI/Icono.svelte";
  import {nombreCompleto} from '../../Modelos/Trabajador';
  import Boton from "./Boton.svelte";

  export let id;
  export let label;
  export let trabajadores;
  export let valido = true;
  export let mensajeDeError = "";
  export let icono = 'people';
  export let value;

  const dispatch = createEventDispatcher();

  let visible = false;
  let touched = false;
  let valorMostrado = '';

  const cambiaTrabajador = trabajador => () => {
    if (value.indexOf(trabajador) >= 0) {
      dispatch('change', value.filter(x => x !== trabajador));
    } else {
      dispatch('change', [...value, trabajador]);
    }
  };

  const marcarTodos = () => dispatch('change', [...trabajadores]);
  const desmarcarTodos = () => dispatch('change', []);

  let filtro = '';
  const actualizaFiltro = e => filtro = e.target.value.toLowerCase();
  const vaciaFiltro = () => filtro = '';

  $: {
    if (trabajadores.length === value.length) {
      valorMostrado = 'Todos';
    } else {
      const nombres = value.map(x => x.nombre);
      valorMostrado = nombres[0] || 'Todos';
      if (nombres.length > 1) {
        valorMostrado += ` y ${nombres.length - 1} más`;
      }
    }
  }
</script>

<style>
    .contenido-modal {
        display: grid;
        grid-template-columns: 1fr max-content;
        grid-template-rows: max-content max-content;
    }

    .filtro {
        grid-column: 1;
        grid-row: 1;
    }

    .filtro > .inner {
        display: flex;
    }

    .filtro button {
        padding: 0 .5em;
        border: 1px solid var(--acentos);
        background: transparent;
        color: var(--acentos);
    }

    .filtro input {
        border: 1px solid var(--bordes);
        border-right: 0;
    }

    .opciones {
        grid-column: 2;
        grid-row: 1;
    }

    .trabajadores {
        grid-column: 1 / 3;
        grid-row: 2;
    }

    .campo {
        border: 2px solid var(--bordes);
        border-radius: 3px 3px 0 0;
        display: flex;
    }

    .icono {
        flex: 0 0 auto;
        background: var(--bordes);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--negro);
        padding: .25rem;
    }

    input,
    textarea {
        display: block;
        width: 100%;
        font: inherit;
        border: none;
        background: white;
        padding: 0.25em 1em;
        transition: border-color 0.1s ease-out;
    }

    input:focus,
    textarea:focus {
        border-color: #e40763;
        outline: none;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .invalid {
        border-color: var(--acentos);
    }

    .invalid .icono {
        background: var(--acentos);
    }

    .error-message {
        color: red;
        margin: 0.25rem 0;
    }

    .trabajadores {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(10em, 1fr));
        grid-gap: var(--padding-global);
    }

    .trabajador {
        display: flex;
        align-items: center;
        --color-icono: var(--acentos);
    }

    .opciones {
        display: flex;
        justify-content: flex-end;
        margin-bottom: var(--padding-global);
    }

    .opcion:not(first-child) {
        margin-left: var(--padding-global);
    }

    .activo {
        --color-icono: var(--verde);
    }
</style>

<div class="form-control" on:click={() => visible = true}>
    <label for={id}>{label}</label>
    <div class="campo" class:invalid="{!valido && touched}">
        {#if icono}
            <div class="icono">
                <i class="material-icons">{icono}</i>
            </div>
        {/if}

        <input type="text" id={id} value={valorMostrado} on:input readonly
               on:focus={() => visible = true}/>
    </div>
    {#if mensajeDeError && !valido && touched}
        <p class="error-message">{mensajeDeError}</p>
    {/if}
</div>

{#if visible}
    <Modal on:cancel={() => visible = false} title="Selección de trabajadores">
        <div class="contenido-modal">
            <div class="filtro">
                <div class="inner">
                <input type="text" value={filtro} on:input={actualizaFiltro} placeholder="Nombre">
                <button on:click={vaciaFiltro} type="button">X</button>
                </div>
            </div>
            <div class="opciones">
                <div class="opcion">
                    <Boton tamano="pequeno" on:click={marcarTodos}>
                        <Icono margen>check</Icono>
                        Marcar todos
                    </Boton>
                </div>

                <div class="opcion">
                    <Boton tamano="pequeno" on:click={desmarcarTodos}>
                        <Icono margen>cancel</Icono>
                        Desmarcar todos
                    </Boton>
                </div>
            </div>

            <div class="trabajadores">
                {#each trabajadores.filter(x => !filtro || nombreCompleto(x).toLowerCase().indexOf(filtro) >= 0) as trabajador (trabajador.id)}
                    <div class="trabajador" class:activo={value.indexOf(trabajador) >= 0}
                         on:click={cambiaTrabajador(trabajador)}>

                        {#if value.indexOf(trabajador) >= 0}
                            <Icono tamano={20} margen>check</Icono>
                        {:else}
                            <Icono tamano={20} margen>cancel</Icono>
                        {/if}

                        {nombreCompleto(trabajador)}
                    </div>

                {/each}
            </div>
        </div>
    </Modal>
{/if}
